import { Component } from 'react';
import { NSARouterMakerResult } from "namirasoft-account-react";
import { SupportLayout } from "../SupportLayout";
import { SupportProps } from "../SupportProps";
import { SupportEntities } from "../SupportEntities";

export interface CategoryListPageProps extends NSARouterMakerResult, SupportProps { }

class CategoryListPage extends Component<CategoryListPageProps>
{
    override render()
    {
        return (
            <SupportLayout
                {...this.props}
                action={{
                    description: "This section displays the available ticket categories to help you select the most appropriate option when submitting a ticket, allowing the support team to respond more quickly and accurately."
                }}
                pages={{
                    entity: SupportEntities.category(this.props),
                    ui: {
                        action: {
                            menus: {
                                view_history: false
                            }
                        }
                    },
                    list: {
                        ui: {
                            tab_page_view: {
                                tabs: {
                                    history: false
                                }
                            },

                        }
                    }
                }}
            >
                <></>
            </SupportLayout>
        );
    }
}

export default CategoryListPage;